"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const auth0_react_1 = require("@auth0/auth0-react");
const apiUtils_1 = require("../util/apiUtils");
const auth_1 = require("../util/auth");
const useEdit = (url, callback) => {
    const { getAuthHeader, getAccessTokenSilently } = (0, auth_1.useAuthentication)();
    const { loginWithRedirect } = (0, auth0_react_1.useAuth0)();
    const [state, setState] = (0, react_1.useState)({
        status: apiUtils_1.LoaderStatus.Idle,
    });
    const executeEdit = async (body, method) => {
        setState({ status: apiUtils_1.LoaderStatus.Loading });
        try {
            let accessToken;
            try {
                accessToken = await (0, auth_1.getAccessToken)(getAccessTokenSilently);
            }
            catch (error) {
                if ((0, auth_1.shouldTriggerLoginRedirect)(error)) {
                    loginWithRedirect();
                    return;
                }
                throw error;
            }
            const authHeader = getAuthHeader(accessToken);
            const response = await fetch((0, apiUtils_1.getAPIUrl)() + url, {
                method,
                headers: {
                    "Content-Type": "application/json",
                    ...authHeader,
                },
                body: body && JSON.stringify(body),
            }).finally(() => {
                if (callback) {
                    callback();
                }
            });
            if ((0, auth_1.shouldTriggerLoginRedirect)(undefined, response.status)) {
                loginWithRedirect();
                return;
            }
            const data = await response.json();
            setState({ status: apiUtils_1.LoaderStatus.Success, data });
        }
        catch (error) {
            if ((0, auth_1.shouldTriggerLoginRedirect)(error)) {
                loginWithRedirect();
                return;
            }
            console.error(error);
            setState({ status: apiUtils_1.LoaderStatus.Error, error });
        }
    };
    return [state, executeEdit];
};
exports.default = useEdit;
